<template>
  <div>
    <company-edit
      v-if="$store.state.company.company"
      :item="{ ...$store.state.company.company }"
      :on-submit="isCreate ? create : update"
      :on-delete="deleteItem"
    />

    <div v-if="isAdmin && !isCreate">
      <user-list :items="$store.state.user.users" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CompanyEdit from '../components/company/CompanyEdit.vue'
import UserList from '../components/user/UserList.vue'
import UserMixin from '../mixins/UserMixin'

export default {
  name: 'CompanyProfile',
  components: {
    CompanyEdit,
    UserList
  },
  mixins: [UserMixin],
  data: () => ({
    isCreate: null
  }),
  methods: {
    ...mapActions('company', [
      'createCompany',
      'getCompany',
      'updateCompany',
      'deleteCompany'
    ]),
    ...mapActions('user', ['getUsersByCompany']),
    create(companyData) {
      this.createCompany(companyData)
      this.$router.push('/companies')
    },
    update(companyData, companyId) {
      this.updateCompany({ companyId, companyData })
      this.$router.go()
    },
    deleteItem(companyId) {
      this.deleteCompany(companyId)
      this.$router.push('/companies')
    }
  },
  mounted() {
    const id = this.$route.params.id
    if (id === 'create') {
      this.isCreate = true
      this.$store.commit('company/getCompanySuccess', {
        name: ''
      })
    } else {
      this.isCreate = false
      this.getCompany(this.$route.params.id)

      if (this.isSystemAdmin) {
        this.getUsersByCompany(id)
      }
      if (this.isCompanyAdmin) {
        this.getUsersByCompany(this.$store.state.auth.user.company)
      }
    }
  }
}
</script>
